module.exports = __webpack_public_path__ + "static/img/logo.a13e.393d3c7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.a13e.svg
// module id = jY2b
// module chunks = 18